import type { Company } from "../company";
import { getGlobalHeadersAsObject } from "../global-headers";

export type SalesCompany = Company & {
	stakeholders: {
		id: number;
		name: string;
		contact_info: any;
		summary: string;
		extra_info: string;
		source: any;
		url: string;
		headling: string;
	}[];
};

export type CompanySales = {
	lead: SalesCompany[];
	contact: SalesCompany[];
	signed: SalesCompany[];
	first_deal: SalesCompany[];
};

export const getSalesCompanies = (): Promise<CompanySales> => {
	const requestUrl = "/api/v2/sales/companies";

	return fetch(`${requestUrl}`, {
		method: "GET",
		headers: getGlobalHeadersAsObject(),
	})
		.then((res) => res.json())
		.catch((err) => console.log(err));
};
